module.exports = __webpack_public_path__ + "static/media/OdometerCard.6815a4ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scan/OdometerCard.svg
// module id = 787
// module chunks = 0